import {Component, OnInit} from '@angular/core';
import {IconUtil} from '../../../util/icon.util';
import {SachetAction} from '../../../model/sachet-action.model';
import {DateUtil} from '../../../util/date.util';
import {UserService} from '../../../services/user.service';
import {SachetStockService} from '../../../services/sachet-stock.service';
import {SachetStock} from '../../../model/sachet-stock.model';
import {SachetEditing} from '../../../model/sachet-editing.model';
import {SachetActionHelper} from '../../../helpers/sachet-action.helper';
import {SachetTypeEnum} from '../../../constants/sachet-type.enum';
import {ActionTypeEnum} from '../../../constants/action-type.enum';
import {UnapModel} from '../../../model/unap.model';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

    datepickerOpts = {
        language: 'es',
        startDate: DateUtil.addDays(new Date(), -365),
        endDate: new Date(),
        autoclose: true,
        todayBtn: 'linked',
        todayHighlight: true,
        assumeNearbyYear: true,
        format: 'dd/mm/yyyy',
        placeholder: 'dd/mm/yyyy',
        icon: 'fa fa-calendar',
    };

    searching: boolean = false;
    sachetsStock: SachetStock = new SachetStock();
    organizationStock: SachetStock;
    sachetsEditing = new SachetEditing();
    action: SachetAction = new SachetAction();
    actions: SachetAction[] = [];
    sachetsTypes: string[] = [SachetTypeEnum.RED, SachetTypeEnum.YELLOW];
    configs: any = {};

    constructor(private userService: UserService,
                private sachetService: SachetStockService,
                private sachetHelper: SachetActionHelper) {

    }

    getActions() {
        if (!this.actions) {
            return [];
        }
        return this.actions.sort((a, b) => b.dateTimestamp - a.dateTimestamp);
    }

    newAction() {
        this.action = new SachetAction();
        this.sachetsEditing = new SachetEditing();
        this.sachetsStock = new SachetStock();
    }

    get attention() {
        return IconUtil.getIcon('exclamation-triangle');
    }

    get user() {
        return this.userService.getLocalStorageUser();
    }

    getClass(counter: number, actionType?: string) {
        if (actionType) {
            return 'black';
        }
        if (counter < 0) {
            return 'negative';
        } else {
            return 'positive';
        }
    }

    getCounterLabel(counter: number, actionType?: string) {
        if (actionType === ActionTypeEnum.EDITED_STOCK) {
            return counter;
        }
        if (counter < 0) {
            return counter;
        } else {
            return `+${counter}`;

        }
    }

    aggregate(modal: any) {

        if (SachetTypeEnum.RED === this.sachetsStock.sachetType) {
            this.organizationStock.redCount += this.sachetsStock.counter;
            this.action.sachetType = SachetTypeEnum.RED;
        } else {
            this.organizationStock.yellowCount += this.sachetsStock.counter;
            this.action.sachetType = SachetTypeEnum.YELLOW;
        }

        this.action.counter = this.sachetsStock.counter;

        this.generateBatch();
        this.generateAction();

        modal.hide();
    }

    editInventor(modal: any) {

        this.organizationStock.date = this.sachetsStock.date;
        if (this.sachetsStock.redCount > 0) {
            this.organizationStock.redCount = this.sachetsStock.redCount;
            this.action.counter = this.sachetsStock.redCount;
            this.action.sachetType = SachetTypeEnum.RED;
            this.generateEditingAction();
        }

        if (this.sachetsStock.yellowCount > 0) {
            this.organizationStock.yellowCount = this.sachetsStock.yellowCount;
            this.action.counter = this.sachetsStock.yellowCount;
            this.action.sachetType = SachetTypeEnum.YELLOW;
            this.generateEditingAction();
        }

        this.generateEditing();


        // this.sachetService.update(this.sachetsStock).then(() => {
        //     console.log('Stock updated');
        // });
        //
        // if (this.sachetsStock && this.sachetsStock.redCount > 0) {
        //     this.action.sachetType = SachetTypeEnum.RED;
        // } else {
        //     this.action.sachetType = SachetTypeEnum.YELLOW;
        // }
        //
        // this.action.counter = this.sachetsStock.counter;
        //
        // // this.generateBatch();
        // this.generateAction();

        modal.hide();
    }

    generateAction() {

        const action = this.sachetHelper.generateSachetBatch(this.action, this.user, this.sachetsStock.date);
        this.sachetService.saveAction(action).then(() => {
            console.log('Action saved');
        });
    }

    generateEditingAction() {
        const action = this.sachetHelper.editSachetBatch(this.action, this.user, this.sachetsStock.date);
        this.sachetService.saveAction(action).then(() => {
            console.log('Action saved');
        });
    }

    generateBatch() {
        this.sachetService.save(this.organizationStock).then(() => {
            console.log('Stock saved');
        });
    }

    generateEditing() {
        this.sachetService.update(this.organizationStock).then(() => {
            console.log('Stock updated');
        });
    }

    initStock() {
        const suffix = this.user.organizationModel.id;
        this.sachetsStock = new SachetStock();
        this.sachetsStock.code = `sachets-stock-${suffix}`;
    }

    isRedStockLow() {
        return this.configs?.red?.UNAP >= this.organizationStock?.redCount;
    }

    isYellowStockLow() {
        return this.configs?.yellow?.UNAP >= this.organizationStock?.yellowCount;
    }

    ngOnInit(): void {
        this.sachetService.verifyStock(this.user).subscribe(stock => {
            if (stock) {
                this.organizationStock = stock;
            } else {
                this.initStock();
                this.sachetService.save(this.sachetsStock).then(() => {
                    console.log('Stock saved');
                });
            }
        });

        this.sachetService.getActionsByOrganizationId(this.user.organizationModel.id).subscribe(values => {
            this.actions = [];
            this.actions = values;
        });

        this.sachetService.getSachetsConfig().subscribe(config => {
            this.configs = config;
        });

    }

}
